export default __webpack_public_path__ + "static/media/3.9481767a.jpg";